import React, { useEffect } from 'react'
import { ThemeProvider } from 'styled-components'

import GlobalStyles from '~/styles/GlobalStyles'
import theme from '~/styles/theme'
// @ts-ignore
import firebase from '~/utils/firebase'
import '~/static/fonts/fonts.css'

const Layout: React.FC = ({ children }) => {
  useEffect(() => {
    firebase.labels.listenToLabels()
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />
        {children}
      </>
    </ThemeProvider>
  )
}

export default Layout
